<template>
    <div>
        <td class="col-xs-12 col-sm-4 col-md-4">
            {{sku.name}}
        </td>
        <td class="col-xs-6 col-sm-4 col-md-4">
            {{sku.price.amount | money(sku.price.currency)}}
        </td>
        <td class="col-xs-2 col-sm-2 col-md-2">
            <div class="input-group mb-3">
                <div class="input-group-append">
                    <button class="btn btn-dark btn-sm text-center"
                            v-on:click.prevent="$emit('decreased')"><i
                            class="fa fa-minus mr-0"></i></button>
                </div>

                {{sku.quantity}}
                <div class="input-group-prepend">
                    <button class="btn btn-dark btn-sm text-center"
                            v-on:click.prevent="$emit('increased')"><i
                            class="fa fa-plus mr-0"></i></button>
                </div>
            </div>
        </td>
    </div>
</template>


<script>
    import {money} from '../../Utility/filters/money'

    export default {
        name: "sku",
        props: {
            sku: {
                type: Object,
                default: () => ({})
            }
        },
        filters: {
            money,
        },
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/Skus/Form/Quantity.vue